import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { find } from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import enhanceWithClickOutside from 'react-click-outside';
import NumberDisplay from '../../../../components/number-display';

const periods = [
  {
    value: 'monthly',
    label: 'Monthly',
  },
  {
    value: 'quarterly',
    label: 'Quarterly',
  },
  {
    value: 'annual',
    label: 'Annual',
  },
  null,
  {
    value: 'days',
    label: 'Custom Period',
  },
];

class PeriodDropdown extends Component {
  constructor() {
    super();
    this.state = {
      dropdownOpen: false, //
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleTogglePeriodItem = this.handleTogglePeriodItem.bind(this);
  }

  handleToggle(dropdownOpen) {
    if (dropdownOpen) {
      this.setState({ dropdownOpen });
    }
  }

  handleClickOutside() {
    if (this.state.dropdownOpen) {
      // recalculate
    }
    this.setState({ dropdownOpen: false });
  }

  handleTogglePeriodItem(period) {
    if (period.value === 'days') {
      this.props.onCustomPeriodSelect();
    } else {
      this.setState({ dropdownOpen: false });
      this.props.onChange(period.value);
    }
  }

  render() {
    const { dropdownOpen } = this.state;
    const { period, days } = this.props;
    const selected = find(periods, { value: period });
    let periodLabel = selected ? selected.label : 'Select a period';
    let dropdownPeriodLabel = selected ? selected.label : 'Select a period';
    const isCustom = period === 'days' && days !== null;
    if (isCustom) {
      periodLabel = (<NumberDisplay value={days} suffix="day" precision={0} suffixIsUnit />);
      dropdownPeriodLabel = (<NumberDisplay value={days} suffix=" day" precision={0} />);
    }
    return (
      <span>
        <Dropdown
          id="period-dropdown"
          onToggle={this.handleToggle}
          open={dropdownOpen}
        >
          <Dropdown.Toggle onClick={this.handleClickOutside} bsSize="small">
            <span>{dropdownPeriodLabel}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {periods.map((p) => {
              if (p === null) {
                return (
                  <MenuItem divider key="divider" />
                );
              }
              const active = period === p.value;
              return (
                <MenuItem
                  active={active}
                  key={p.value}
                  onSelect={() => { this.handleTogglePeriodItem(p); }}
                >
                  {p.label}{isCustom && active && <span>&nbsp;({periodLabel})</span>}
                </MenuItem>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </span>
    );
  }
}

PeriodDropdown.propTypes = {
  onChange: PropTypes.func,
  onCustomPeriodSelect: PropTypes.func,
  days: PropTypes.number,
  period: PropTypes.string,
};

PeriodDropdown.defaultProps = {
  period: 'Won',
  days: 0,
  onChange: () => {},
  onCustomPeriodSelect: () => {},
};

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

export default connect(mapStateToProps)(enhanceWithClickOutside(PeriodDropdown));
